module.exports = __webpack_public_path__ + "img/_54A2290.94da9554.jpg";